import React, { useState, useEffect} from 'react';
import ReactEcharts from "echarts-for-react";

import {
  Container,
  // Title,
  // Item,
  ButtonClose,
  ButtonGroup,
} from "./styles";

import ReadMoreButton from "../../../../components/UI/ReadMoreButton"

const Grafico = ({
  data=[],
  title={text:"",top:"9%"},
  fullscreen=false,
  visible=false,
  type="bar",
  changeType=false,
  closeFullscreen=()=>{},
  clickOnGrafico=()=>{},
  back=null,
}) => {
  const [dataApi, setDataApi] = useState([]);
  const [option, setOption] = useState({});
  const [seriesApi, setSeriesApi] = useState([]);
  const [styleType, setStyleType] = useState(type);
  const [grid, setGrid] = useState({});

  useEffect(()=>{
  },[]);

  // useEffect(()=>{
  // },[dataApi]);

  // const axisPointerText = (params) => {
  //   console.log(params);
  //   return params.value;
  // };

  const xAxisLabelFormat = (value,index) => {
    // return value.slice(0,29);
    let regex = new RegExp(`(?![\\S]{1,${14}}$)([\\S\\s]{1,${14}})\\s`, 'g');

    return value.replace(regex, '$1\n');
  }

  // const yAxisLabelFormat = (value,index) => {
  //   return value + "%";
  // }

  const xAxisRotate = () => {
    return 0;
  }

  // const roundValor = (value,precision) =>{
  //   return (Math.round(value*Math.pow(10,precision))/Math.pow(10,precision));
  // }

  const LabelFormatter = (value,index) => {
    if (styleType==="bar"){
      return `${(value[0]?.data.choiceText.endsWith("."))?(value[0]?.data.choiceText.slice(0, -1)):(value[0]?.data.choiceText)}: ${value[0]?.data.countChoiceResponses}`;
    }
    if (styleType==="pie"){
      console.log(value);
      return `${(value?.data.choiceText.endsWith("."))?(value?.data.choiceText.slice(0, -1)):(value?.data.choiceText)}: ${value?.data.countChoiceResponses} (${value.percent}%)`;
    }
    return "";
  }

  useEffect(()=>{
    let style = {
        type:styleType,
        color:'green',
        markline:{
          lineStyle:{
            color:'green',
            dashOffset: 5,
            opacity:1
          }
        }
        // markLine: {
        //   data: [{ type: 'average', name: 'Média' }]
        // }
      };
    if (styleType==="pie"){
      setGrid({left:'150%', right:0});
      style = {
        type:styleType,
      };
    }

    if (styleType==="disc"){
      setGrid({left:'150%', right:0});
      style = {
        type:"pie",
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
          formatter: (value)=>{return `${value.value.choiceText}\n\n${value.value.countChoiceResponses} - ${value.percent}%`}
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
      };
    }
    if (styleType==="bar"){
      setGrid({height:"350px"});
    }

    setSeriesApi([
      style,
      // {
      //   type:'bar',
      //   color:'red',
      //   // markLine: {
      //   //   data: [{ type: 'average', name: 'Média' }]
      //   // }
      // },
    ]);

    //o tipo de gráfico deve ser definido no inicio da carga da página não podendo variar dentro da página
    //para definir o tipo de gráfico talvez possa ser interessante já vir diretamente pelo endereço

    setDataApi({
      dimensions: [
        "choiceText", 
        {
          name:'countChoiceResponses',
          displayName:'respostas',
        }
      ],
      /*
        dimensions:[eixoX,eixo1,...,eixoN] 
        o primeiro valor do vetor são os valores utilizados para o eixo x
        podendo ser usado o nome do parametro do vetor utilizado
        os valores seguintes são os que fazem referencia aos valores para serem utilizados em relação ao eixo X 
      */
      source: data,
    });

  },[data,type,styleType]);

  useEffect(()=>{
    setOption({
      title:{
        show:true,
        text: `${title.text}`,
        left:'center',
      },
      xAxis:{
        type: 'category',
        axisLabel: {
          interval: 0, 
          rotate: xAxisRotate(), 
          fontSize: 10,
          formatter: xAxisLabelFormat,
        },
        axisPointer:{
          handle:{
            show:true,
            margin: 220,
          },
        },
      },
      yAxis:{
        type:'value',
      },
      grid,
      legend:{show: true, left:'1%', bottom:'2%', orient:'horizontal', itemWidth: 30},
      tooltip:{
        trigger:`${styleType==="pie"?'item':'axis'}`,
        formatter: LabelFormatter
      },
      // axisPointer:{
      //   type: 'line',
      //   // label:{
      //   //   formatter:axisPointerText,
      //   // },
      // },
      dataset: dataApi,
      series: seriesApi,
      toolbox:{
        show:true,
        feature:{
          saveAsImage: {},
        }
      }
    });
    //console.log("title",title);
    // eslint-disable-next-line
  },[dataApi,seriesApi]);

  function onChartClick(param, echarts) {
    clickOnGrafico(param);
    // console.log('OnChartClick',param, echarts);

  };

  function onChartReady(echarts) {
    //console.log('OnChartReady', echarts);
  };

  function onChartMouseOver(param) {
    // console.log('mouseOver',param);
  };

  function onChartLegendselectchanged(param, echarts) {
    // console.log('onChartLegendselectchanged',param, echarts);
  };

  return (
    <Container fullscreen={fullscreen} visible={visible}>
        <ReactEcharts 
          option={option} 
          style={{width:'100%', 'height':'600px'}} 
          opts={{renderer:'canvas'}} 
          onChartReady={onChartReady}
          onEvents={{
            'click': onChartClick,
            'legendselectchanged': onChartLegendselectchanged,
            'mouseover': onChartMouseOver
          }}
        />
        {changeType && <ButtonGroup>
          <ReadMoreButton onClick={()=>{setStyleType("bar")}} text={"Bar"}/>
          <ReadMoreButton onClick={()=>{setStyleType("pie")}} text={"Disco"}/>
          <ReadMoreButton onClick={()=>{setStyleType("disc")}} text={"Disco 2"}/>
        </ButtonGroup>}
    </Container>
  );
};

export default Grafico;